import Vue from 'vue'
import Router from 'vue-router'

// รายการ Vue File
import Login from '@/components/Login'
import LoginStaff from '@/components/LoginStaff'
// import Verify from '@/components/Verify'

// รายการ Vue Folder
import Refund from '@/components/Refund'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/StaffLogin',
      name: 'StaffLogin',
      component: LoginStaff
    },
    {
      path: '/Certificate',
      name: 'Certificate',
      component: Refund.Certificate
    },
    {
      path: '/Slips/Search',
      name: 'SearchSlips',
      component: Refund.SearchSlips
    },
    {
      path: '/Request',
      name: 'Request',
      component: Refund.RequestDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js